import { USER_IMPORT } from '@/config/config_api_backend'
import http from '../plugins/http'

const apiGetDemoImportFileAsArrayBuffer = async () => {
  try {
    let response = await http.get(USER_IMPORT.GET_DEMO_FILE, {
      responseType: 'arraybuffer',
    })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

const apiUploadFile = async (file) => {
  try {
    const formData = new FormData()
    formData.append('file', file)

    let response = await http.put(USER_IMPORT.PUT_FILE, formData, { 'Content-Type': 'multipart/form-data' })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

const createUserFromFile = async (data) => {
  try {
    let response = await http.put(USER_IMPORT.CREATE_USER, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

export { apiGetDemoImportFileAsArrayBuffer, apiUploadFile, createUserFromFile }
